export default {
  snapInfo: {
    production: {
      snapUrl: 'https://app.midtrans.com/snap/snap.js',
      snapToken: 'Mid-client-hKACyhF4wRpKWtbc',
    },
    staging: {
      snapUrl: 'https://app.sandbox.midtrans.com/snap/snap.js',
      snapToken: 'SB-Mid-client-l41rh1F5DtjYpbr_',
    },
  }[process.env.VUE_APP_SNAP_ENV || 'staging'],
  needBindBankPrevious: true,
  needElectronicContract: false,
}
